import { NgModule } from '@angular/core';
import { DateMomentPipe } from './date-moment.pipe';
import { IncludesPipe } from './includes.pipe';
import { CountryCodeToISOLocalePipe } from './iso-locale.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { TranslationByCountryPipe } from './translation-by-country.pipe';
import { UserPositionPipe } from './user-position.pipe';

@NgModule({
  exports: [
    SafeHtmlPipe,
    IncludesPipe,
    DateMomentPipe,
    UserPositionPipe,
    TranslationByCountryPipe,
    CountryCodeToISOLocalePipe,
  ],
  declarations: [
    SafeHtmlPipe,
    IncludesPipe,
    DateMomentPipe,
    UserPositionPipe,
    TranslationByCountryPipe,
    CountryCodeToISOLocalePipe,
  ],
})
export class PipesModule {}
